/* Client API — jeton invité en localStorage, CSRF via meta tag, session admin en cookie. */

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content || '';

export const guestToken = {
  get: () => localStorage.getItem('olivia-guest-token'),
  set: (t) => localStorage.setItem('olivia-guest-token', t),
  clear: () => localStorage.removeItem('olivia-guest-token'),
};

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

async function request(method, url, body) {
  const headers = { Accept: 'application/json' };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (method !== 'GET') headers['X-CSRF-Token'] = csrfToken();
  const token = guestToken.get();
  if (token && !url.startsWith('/api/admin')) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(url, {
    method,
    headers,
    credentials: 'same-origin',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.error || `Erreur ${res.status}`);
  return data;
}

export const api = {
  get: (url) => request('GET', url),
  post: (url, body = {}) => request('POST', url, body),
  patch: (url, body = {}) => request('PATCH', url, body),
  del: (url) => request('DELETE', url),
};
